import React from 'react';
import Helmet from 'react-helmet';
import { Link } from 'react-router-dom';
import { lang } from '../lang_pp';

const PrivacyPolicy = () => (
  /**
   * This is just a sample Privacy Policy content.
   */

  <div className="main-container -pages">
    <Helmet>
      <title>{lang.title}</title>
      <meta name="robots" content="noindex, nofollow" />
      <meta name="description" content={lang.description} />
    </Helmet>

    <h1>{lang.pp}</h1>

    <p>
      <h3>{lang.pp_sub_head}</h3>
      {lang.pp_sub_content1}
    </p>

    <p>{lang.pp_sub_content2}</p>

    <h3>{lang.pp_information}</h3>

    <ol>
      <li>{lang.pp_info1}</li>

      <li>{lang.pp_info2}</li>

      <li>{lang.pp_info3}</li>

      <li>{lang.pp_info4}</li>

      <li>{lang.pp_info5}</li>

      <li>{lang.pp_info6}</li>

      <li>{lang.pp_info7}</li>

      <li>{lang.pp_info8}</li>

      <li>{lang.pp_info9}</li>
    </ol>

    <p>{lang.pp_info_footer}</p>

    <h3>{lang.pp_info_we_collect}</h3>

    <p>{lang.pp_info_we_collect_def}</p>

    <ol>
      <li>{lang.pp_info_we_collect1}</li>
      <li>{lang.pp_info_we_collect2}</li>
      <li>{lang.pp_info_we_collect3}</li>
    </ol>

    <h3>{lang.pp_how_we_share}</h3>

    <p>{lang.pp_how_we_share_content1}</p>

    <p>{lang.pp_how_we_share_content2}</p>

    <p>{lang.pp_how_we_share_content3}</p>

    <h3>{lang.pp_right_to_access}</h3>

    <p>{lang.pp_right_to_access_content}</p>

    <h3>{lang.pp_consent}</h3>

    <p>{lang.pp_consent_content}</p>

    <h3>{lang.pp_merger}</h3>

    <p>{lang.pp_merger_content}</p>

    <h3>{lang.pp_special}</h3>
    <p>{lang.pp_special_sub1}</p>

    <p>{lang.pp_special_sub2}</p>

    <p>{lang.pp_date_updated} 05/25/2018</p>

    <p>
      {lang.pp_questions}
      <span className="d-block">BeeStripe LLC</span>
      <span className="d-block">PO BOX 22986</span>
      <span className="d-block">Honolulu, HI USA</span>
      <span className="d-block">
        E-mail: <a href="mailto:support@beestripe.com">support@beestripe.com</a>
      </span>
    </p>
  </div>
);

export default PrivacyPolicy;



// WEBPACK FOOTER //
// ./src/pages/PrivacyPolicy.js